import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClipboard2"><Path d="M16.5 4.5H20.5V21.5H3.5V4.5H7.5M7.5 2.5H16.5V6.5H7.5V2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconClipboard2;
